import { flattenRelationNN } from "@archipad-js/core/orm";

import { PhaseGeneratedEntity } from "./generated/PhaseGeneratedEntity";
import { BugGroupEntity } from "./BugGroupEntity";

export abstract class PhaseEntity extends PhaseGeneratedEntity {
    public get nameComputed(): string {
        const localizer = this.entityContext.localizationService;

        if (this.nameSystem && localizer.isLocalized(this.nameSystem)) {
            return String(localizer.getFormatted(this.nameSystem));
        }

        const length = this.name?.length ?? 0;
        return length > 0 ? (this.name ?? "") : (this.nameSystem ?? "");
    }

    public get bugGroups(): ReadonlyArray<BugGroupEntity> {
        return flattenRelationNN<PhaseEntity, BugGroupEntity>(this, "bugGroupsRelations", "bugGroup");
    }
}
